module.exports = __webpack_public_path__ + "fonts/Austin-Medium.30e3f2e9.otf";